/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_WrongInputs */

const zh_learn_wrong = /** @type {(inputs: Learn_WrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误`)
};

const en_learn_wrong = /** @type {(inputs: Learn_WrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wrong`)
};

const es_learn_wrong = /** @type {(inputs: Learn_WrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorrecto`)
};

/**
* | output |
* | --- |
* | "Wrong" |
*
* @param {Learn_WrongInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const learn_wrong = /** @type {((inputs?: Learn_WrongInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_WrongInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_wrong(inputs)
	if (locale === "en") return en_learn_wrong(inputs)
	return es_learn_wrong(inputs)
});